import { asyncAction } from 'lib/actionCreators'

export const recruiterProfile = asyncAction('recruiter/RECRUITER_PROFILE')
